angular.module('rjmNg.api').factory('RemoteStructures', [
  "serviceUrl"
  "app"
  "modelFactory"
  (serviceUrl, app, modelFactory) ->
    RemoteStructures = modelFactory serviceUrl("/clients/#{app.getClientId()}/remote-structures"),
      httpConfig:
        withCredentials: true
      cacheOptions:
        deleteOnExpire: 'passive'

    return RemoteStructures
  ]
)
